import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Button } from '@mui/material'
import useTranslation from '../../../hooks/useTranslation'


const FileUpload = ({ name, onChange }) => {
  const { t } = useTranslation()

  return (
    <FormGroup>
      <Button variant="outlined" component="label">
        {t('labels.upload')}
        <input style={{ display: 'none' }} accept="image/*" multiple type="file" name={name} onChange={onChange} />
      </Button>
    </FormGroup>
  )
}

FileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default FileUpload
